import { computed, ComputedRef, ref } from 'vue';
import { getPageSubdomain } from '@/utils/helper';
import { getOnlineGiving } from './useGiving';
import { OnlineGiving } from '@/views/home/types';

const state = ref({ organization: {} as OnlineGiving });

const organization: ComputedRef<OnlineGiving> = computed(() => {
    return state.value.organization;
});

const check = (): boolean => {
    if (Object.entries(state.value.organization).length !== 0) {
        return true;
    }

    return false;
};

const clear = (): void => {
    state.value.organization = {} as OnlineGiving;
};

function setOrganization (org: OnlineGiving): void {
    state.value.organization = org;
}

async function fetchOrganization (): Promise<void> {
    const slug = getPageSubdomain();

    const response = await getOnlineGiving(slug);
    const jsonResponse = await response.json();

    if (jsonResponse) {
        setOrganization(jsonResponse);
    }
}

const organizationState = {
    organization,
    clear,
    check
};

export { organizationState, fetchOrganization };
